import ColocadoresList from './ColocadoresList'

export default {
  list: ColocadoresList,
}
